export class DeviceService {
    static setBlackBoxId() {
        if (localStorage.getItem('blackboxId')) {
            console.log('blackboxId already set');
            return;
        }

        const hasIovationLoaded = window.IGLOO && window.IGLOO.getBlackbox;

        if (!hasIovationLoaded) {
            console.error('Iovation script has failed to load');
        }

        console.log('Checking for blackboxId');

        const blackBoxId = hasIovationLoaded ? (window.IGLOO.getBlackbox().blackbox) : ';';

        if (blackBoxId == ';') {
            console.error('window.IGLOO.getBlackbox failed to retrieve BlackboxId');
        }

        console.log('Setting blackboxId to localStorage');

        localStorage.setItem('blackboxId', blackBoxId);
    }
}
